module.exports = __webpack_public_path__ + "img/检测中心大头针.603171f9.png";